import React from "react";

import { Box, Link, Icon, IconButton, Divider, Card, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import LinkIcon from '@mui/icons-material/Link';
import SolutionIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

// common
import { dic } from "@common/text_defs";
// component
import ImgFeatureCross from "@imgs/bi-all-data-ok.png";
import ImgFeatureSupport from "@imgs/bi-mont-support.png";
import ImgFeatureSearch from "@imgs/bi-search.png";

const FeatureSection = () => {

  const itemList = [
    {
      icon: (ImgFeatureCross),
      name: `様々なシステムのデータ連携・統合管理が可能`,
      text1: `クラウドサービスや社内のシステムなど様々なシステムへの接続コネクタが用意されており、コード開発が不要ですぐに利用できます。データは、メタデータ管理され、データの流れの可視化・自動検証・蓄積を行うデータ統合基盤としても利用できます。`,
    },
    {
      icon: (ImgFeatureSupport),
      name: `導入コンサルから構築・運用までのサポート`,
      text1: `導入コンサルティングから、連携システム構築、システム間の連携設定、導入後の運用・保守などのトータルサービスを提供します。データ連携・統合基盤の新規導入検討、既存システムからの移行など幅広い対応が可能です。`,
    },
    {
      icon: (ImgFeatureSearch),
      name: `ビッグデータ分析によるデータ活用支援`,
      text1: `お客様のご要望により、収集したビッグデータをデータサイエンティストが分析してビジネスに活用できるサービスも提供しています。過去の膨大な実績データを分析して需要予測をすることで料金を最適化するなど、ビジネス課題にあわせたデータ活用を支援します。`,
    },
  ];

  return (
    <Box component="section" className="section bg-light-gray" id="works" sx={{ pb: 0 }}>
      <Box component="div" className="container">
        <Box sx={{ mb: 2, }}>
          <SolutionIcon color="primary" sx={{ display: 'block', mx: 'auto', fontSize: '60px' }} />
        </Box>
        <Grid container spacing={3}>
          {itemList.map((pane, index) => (
            <Grid md={4} sm={6} xs={12} key={index}>
              <Card className="relative card" key={index} sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
                <Box component="img" src={pane.icon} sx={{ mx: 'auto', my: 1, textAlign: 'center', width: 64, height: 64, }} />
                <Box sx={{ px: 4, pt: 1 }}>
                  <h5 className="m-0 text-16 font-bold">{pane.name}</h5>
                  <p className="mb-4">{pane.text1}</p>
                </Box>
                <Box sx={{ flexGrow: 1 }}></Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box >
  );
};

export { FeatureSection };
